import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';
import { QuestionsService } from './questions.service';
import { QuestionsQuestionsService } from './questions-questions.service';
import { QuestionsListComponent } from './questions-list/questions-list.component';
import { QuestionsRoutingModule } from './questions-routing.module';
import { QuestionEditorComponent } from './question-editor/question-editor.component';
import { QuestionDetailComponent } from './question-detail/question-detail.component';
import { QuestionsListRowComponent } from './questions-list/questions-list-row/questions-list-row.component';
import { QuestionCreateComponent } from './question-create/question-create.component';

@NgModule({
  imports: [CommonModule, CoreModule, QuestionsRoutingModule],
  declarations: [
    QuestionsListComponent,
    QuestionEditorComponent,
    QuestionDetailComponent,
    QuestionsListRowComponent,
    QuestionCreateComponent
  ],
  exports: [QuestionsListComponent],
  providers: [QuestionsService, QuestionsQuestionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class QuestionsModule {}
